import { useParams } from "react-router-dom";

import ClientNotes from "../../../../clientNotes/ClientNotes";
import { useProviderNotePermissions } from "../../../../clientNotes/hooks/useProviderNotePermissions";

export default function InternalNotes() {
  const { id } = useParams();

  return (
    <div className="h-full min-h-0 overflow-hidden">
      <ClientNotes
        ownerId={id}
        notesRepositoryKey="repositories/provider-notes-repository"
        ownerQueryKey="providerId"
        includeOwnerInCreatePayload={false}
        hideNoteTypeSelector
        hideAISummary
        notePermissionsHook={useProviderNotePermissions}
      />
    </div>
  );
}
